<template>
  <div class="container-recommendation">
    <div class="row">
      <div class="col-12 col-md-12"><h3>{{$t('register.support_recommend')}}</h3></div>
    </div>

    <div class="text-center" v-if="load">
      <span class="loader" ></span>
    </div>

    <div class="row blocks" v-else>
      <label>
        <input type="radio" name="recomendation" value="null" v-model="recommendationId"/>
        <div class="icon-box">
          <img src="https://cliente.masterdaweb.com/modules/addons/mw_comissao/img/sellers/nobody.jpg" style="border-radius: 50%;">
          <span>Nenhum</span>
        </div>
      </label>
      <label v-for="user in users" :key="user.id">
        <input type="radio" name="recomendation" :value="user.id" v-model="recommendationId"/>
        <div class="icon-box">
          <img :src="'http://www.gravatar.com/avatar/'+user.gravatar" style="border-radius: 50%;">
          <span>{{user.firstname}} {{user.lastname}}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
  import {getAxios} from 'services/ajax'

  export default {
    name: "Recommendation",
    data() {
      return {
        model: "two",
        users: [],
        options: [{label: 'One', value: 'one'},
          {label: 'Two', value: 'two'},
          {label: 'Three', value: 'three'}
        ],
        load: true,
        recommendationId: null
      }
    },
    created() {
      this.getAdminUsersList()
    },
    methods: {
      getAdminUsersList() {
        this.load = true

        getAxios().get('customer/user/admin')
          .then(response => {
            this.users = response.data.WhmcsCreateUserClient.data.admin_users;
          })
          .catch(err => {
            this.users = []
          })
          .finally(() => {
            this.load = false
          });
      }
    },
    watch: {
      recommendationId(value){
        this.$emit('recommendationIdEvent', value)
      },
    }
  }
</script>

<style scoped>
  .container-recommendation{
    margin-bottom: 2.5rem;
  }

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
  }

  body {
    background-color: #1b1c24;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }

  .container h1 {
    font-size: 18px;
    line-height: 30px;
    color: #f0eff3;
    text-align: center;
    position: relative;
  }

  .blocks {
    margin: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }

  .blocks label {
    padding: 5px;
    cursor: pointer;
    display: flex;
  }

  .blocks label input[type="radio"] {
    display: none;
  }

  .blocks label .icon-box {
    position: relative;
    display: flex;
    width: 90px;
    padding: 10px;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    color: #000;
    border-radius: 3px;
    font-size: 21px;
    transition: 0.5s;
    user-select: none;
  }

  .blocks label .icon-box img{
    max-width: 40px;
  }

  .blocks label input[type="radio"]:checked ~ .icon-box {
    background: -webkit-gradient(linear, left top, right top, from(#420679), to(#690AC2));
    color: #fff;
  }

  .blocks label .icon-box span {
    margin: 5px;
    font-size: 0.8rem;
    text-align: center;
  }

  @media only screen and (max-width: 992px) {
    .blocks {
      margin: 5px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/recommendation/Recommendation.vue